import { fetchUtils } from 'react-admin';

const DEFAULT_API_BASE_URL = 'https://localhost:8443';

const normalizeBaseUrl = (url) => {
    if (!url) return DEFAULT_API_BASE_URL;
    return url.endsWith('/') ? url.slice(0, -1) : url;
};

export const apiBaseUrl = normalizeBaseUrl(process.env.REACT_APP_API_URL);
export const adminApiUrl = `${apiBaseUrl}/api/admin`;
export const authApiUrl = `${apiBaseUrl}/api/auth`;

const ADMIN_TOKEN_KEY = 'admin_jwt';

const getToken = () =>
    typeof window === 'undefined' ? null : localStorage.getItem(ADMIN_TOKEN_KEY);

export const buildAuthHeaders = (initialHeaders) => {
    const headers =
        initialHeaders instanceof Headers
            ? initialHeaders
            : new Headers(initialHeaders || {});

    if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json');
    }

    const token = getToken();
    if (token && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
};

export const httpClient = (url, options = {}) =>
    fetchUtils.fetchJson(url, {
        ...options,
        headers: buildAuthHeaders(options.headers),
    });

export const adminRequest = (path, { method = 'GET', body, headers, ...rest } = {}) => {
    const finalHeaders = buildAuthHeaders(headers);
    const preparedBody =
        body === undefined || typeof body === 'string' ? body : JSON.stringify(body);

    if (preparedBody !== undefined && !finalHeaders.has('Content-Type')) {
        finalHeaders.set('Content-Type', 'application/json');
    }

    return httpClient(`${adminApiUrl}${path}`, {
        method,
        body: preparedBody,
        headers: finalHeaders,
        ...rest,
    }).then(({ json }) => json);
};

export const adminPatch = (path, body, options) =>
    adminRequest(path, { method: 'PATCH', body, ...options });

export const adminGet = (path, options) =>
    adminRequest(path, { method: 'GET', ...options });
